import { render, staticRenderFns } from "./PaymentStatusAgent.vue?vue&type=template&id=bbe2bc26&"
import script from "./PaymentStatusAgent.vue?vue&type=script&lang=js&"
export * from "./PaymentStatusAgent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports